import { FC } from "react";
import { useRecoilState } from "recoil";
import systemPromptState from "../../../recoil/SystemPrompt";

const SystemPromptInput: FC = () => {
  const [systemPrompt, setSystemPrompt] = useRecoilState(systemPromptState);
  return (
    <div className="mt-8 flex flex-col animate-opensystemprompt">
      <p className="mb-4 font-bold text-xs text-base">System prompt</p>
      <textarea
        className="resize-none rounded-lg border-2 border-gray-300 p-2 text-xs"
        rows={3}
        value={systemPrompt.content}
        onChange={(e) => {
          if (!systemPrompt.changed) {
            setSystemPrompt((prevState) => ({
              ...prevState,
              changed: true,
            }));
          }
          setSystemPrompt((prevState) => ({
            ...prevState,
            content: e.target.value,
          }));
        }}
      />
    </div>
  )
}

export default SystemPromptInput;